<template>
  <div class="sm:flex sm:flex-wrap">
    <options-item v-if="empty" @click="select(false)" :is-selected="isSelected(false)">
      {{ empty }}
    </options-item>
    <options-item
      v-for="value in values"
      :key="value[identifier]"
      @click="select(value)"
      :is-selected="isSelected(value)"
    >
      {{ name ? name(value) : value.name }}
    </options-item>
  </div>
</template>

<script>
import OptionsItem from './OptionsItem'
export default {
  components: { OptionsItem },
  props: {
    modelValue: {},
    values: {
      type: Array,
      required: true,
    },
    name: {
      type: Function,
    },
    identifier: {
      type: String,
      default: 'id',
    },
    empty: {
      type: String,
    },
  },
  watch: {
    values() {
      if (this.modelValue) {
        let identifiers = this.values.map((v) => v[this.identifier])
        let valueIdentifier = this.modelValue[this.identifier]

        if (!identifiers.includes(valueIdentifier)) {
          this.select(null)
        }
      }

      if (this.values.length === 1) {
        this.select(this.values[0])
      }
    },
  },
  methods: {
    isSelected(value) {
      if (value === false && this.modelValue === false) {
        return true
      }

      return this.modelValue && this.modelValue[this.identifier] === value[this.identifier]
    },
    select(type) {
      this.$emit('update:modelValue', type)
    },
  },
  mounted() {
    if (this.values.length === 1) {
      if (this.values[0] === false) {
        this.$emit('update:modelValue', false)
      } else {
        this.$emit('update:modelValue', this.values[0])
      }
    } else if (this.values.length === 0 && this.empty) {
      this.$emit('update:modelValue', false)
    }
  },
  emits: ['update:modelValue'],
}
</script>
